export const isNotDefined = (value: any): boolean => value === null || value === undefined;

// is replacement for previous value != null comparison
export const isDefined = (value: any): boolean => !isNotDefined(value);
